import { Schemas } from '~/clients/api-client'

/**
 * Returns the 3 letter short name of the speciality, as the `short_name` in our database is longer for some of the specialities.
 */
export const getSpecialityShortName = (speciality?: Schemas['SpecialityOut'] | null) => speciality?.short_name.toUpperCase().slice(0, 3) ?? '-'

/**
 * Returns the short name of the speciality, as the `name` in our database is a copy of `fieldOfStudy` in DIPS and is misleading and confusing
 */
export const getSpecialityName = (speciality?: Schemas['SpecialityOut'] | null) => speciality?.short_name ?? '-'
